@if (user$|async; as user) {
  <div
    class="font-bold text-lg"
    >
    Welcome, {{user.name}}!
  </div>
}
